import { IPriceRelevance } from '../../types/newbuilding/priceRelevance';
import { IApplicationState } from '../../types/redux';
import { pathOr } from 'ramda';

export function getPriceRelevance(state: IApplicationState): IPriceRelevance | null {
  return pathOr(null, ['newbuilding', 'relevanceInfo'], state);
}
